import $ from 'jquery';

import '../node_modules/bootstrap-sass/assets/javascripts/bootstrap.js';
import 'slick-carousel';
import './primary-menu.js';
import './lib/svgeezy.js';
import './lib/toggle-section.js';
import './lib/modal.js';
// import './mobile-nav.js';
import './learning-center.js';
import './thewayforward.js';
import * as components from './components';

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference $ with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
        // Use this variable to set up the common and page specific functions. If you
        // rename this variable, you will also need to rename the namespace below.
        var Sage = {
            // All pages
            common: {
                init: function() {
                    // JavaScript to be fired on all pages

					window.primaryMenu();

                    if($(window).innerWidth() >= 900) {
                        $('.country:first-child, .back + .country').addClass('active');
                    }

                    $(window).on('resize', function() {
                        if($(window).innerWidth() >= 900) {
                            $('.country:first-child, .back + .country').addClass('active');
                            $('html').css({overflow: 'visible'});
                        }
                        else {
                            $('.country:first-child, .back + .country').removeClass('active');
                        }
                    });

                    // HERO STUFF
                    var heroTimeout;

                    $(".hero-segment").on("mouseenter", function() {

                        var isVideo = $(this).data("is-video")
                        var target = $(this).data("target");

                        $(".hero-header video").each(function() {
                            $(this)[0].pause();
                        });
                        $(".hero-header .active").removeClass("active");

                        $("#bg-image-" + target).addClass("active");

                        if (isVideo) {
                            $("#bg-image-" + target)[0].play();
                        }

                    });

                    var insightTimeout;
                    $(".hero-cta").on("mouseover", function() {
                        window.clearTimeout(heroTimeout);
                        $(".hero-cta-group .background-image.active").removeClass("active");

                        var target = $(this).data("target");

                        $(".hero-cta-group .background-image.active").addClass("previous");
                        $("#hero-cta-bg-" + target).addClass("active");

                        // resolve 0.9s animation from _home.scss
                        heroTimeout = window.setTimeout(function() {
                            $(".hero-cta-group .background-image.previous").removeClass(
                                "previous active"
                            );
                        }, 900);
                    });

                    // window.mobileNav();
                    window.learningCenter();

                    if($('#brand_grid .brand-family-blocks').length) {
                        init_brand_grid();
                    }
                },
                finalize: function() {
                    // JavaScript to be fired on all pages, after page specific JS is fired
                }
            },
            "learning-center": {
                init: function() {}
            },
            // Home page
            home: {
                init: function() {}
            },
            finalize: function() {},
            // About us page, note the change from about-us to about_us.
            about_us: {
                init: function() {
                    // JavaScript to be fired on the about us page
                }
            },
            // About us page, note the change from about-us to about_us.
            search: {
                init: function() {
                    // JavaScript to be fired on the search page
                    $('form.searchandfilter > ul').addClass('filter-list').addClass('active-3');

                    var filterList = $(".filter-list");
                    filterList.on('keyup', '.sf-input-text', function(e) {
                        $('.search-field').val($(this).val())
                    });
                    filterList.on("click tap", 'h4', function(e) {
                        if ($(e.target).is("h4")) {
                            filterList.toggleClass("active-" + ($(e.target).parent().index() + 1));
                            return;
                        }
                    });
                }
            },
            // About us page, note the change from about-us to about_us.
            international: {
                init: function() {
					var currentCategory = "operations";
					var currentRegion = "intl";
					var currentCategories = ["operations", "inventory", "marketing", "sales", "service", "mobility"];
					var unitedStatesCategoryID = 35;

                    var fetchIntlBrands = function() {
						$.each(currentCategories, function(index, category) { // Iterate over each category.
							$.ajax({
								url: "/wp-json/wp/v2/brands?orderby=title&order=asc&filter[brand_and_solution_category]=" + category + "&per_page=99",
								type: "GET",
								success: function(brandItems) {
									// Create a div for the category.
									var categoryBlock = $('<div>', {
										class: 'brand-family-block-' + category + ' brand-family-block'
									}); 

									$.each(brandItems, function(index, brandItem) {
										if (
											currentRegion === "united-states" &&
											$.inArray(unitedStatesCategoryID, brandItem.region) < 0
										) {
											return;
										}
										if (
											currentRegion === "intl" &&
											$.inArray(unitedStatesCategoryID, brandItem.region) === 0 &&
											brandItem.region.length === 1
										) {
											return;
										}
										
										var hover_image =
                                        brandItem.meta_box.brand_hover_logo.length > 0
                                            ? brandItem.meta_box.brand_hover_logo[0].full_url
                                            : "";

										var white_logo =
										brandItem.meta_box.brand_white_logo.length > 0
											? brandItem.meta_box.brand_white_logo[0].full_url
											: "";

										// Create elements.
										var brandBlockLink = document.createElement("a");
										brandBlockLink.href = brandItem.link;
										brandBlockLink.className = "brand-block";
										brandBlockLink.style.backgroundImage = "url(" + hover_image + ")";

										var brandBlockOverlay = document.createElement("div");
										brandBlockOverlay.className = "brand-block_overlay";

										var whiteLogoImg = document.createElement("img");
										whiteLogoImg.src = white_logo;

										var countryInfoSpan = document.createElement("span");
										countryInfoSpan.className = "country-info";
										countryInfoSpan.textContent = brandItem.meta_box.regional_text;

										// Assemble elements.
										brandBlockOverlay.appendChild(whiteLogoImg);
										brandBlockOverlay.appendChild(countryInfoSpan);

										brandBlockLink.appendChild(brandBlockOverlay);

										// Append to categoryBlock.
										categoryBlock.append(brandBlockLink); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
									});

									var toggleButton = $('<div>', {
										class: 'mobile-brand-toggle',
										id: 'mobile-brand-' + category,
										'data-category': category
									}).append( // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
										$('<div>').text(category.toUpperCase()),
										$('<i>', { class: 'fa fa-chevron-down' })
									); 

									toggleButton.on('click', function() {
										currentCategory = $(this).data('category');
			
										// Toggle button.
										var isActive = $(this).hasClass('active'); // Check if the button is currently active.
										$(".mobile-brand-toggle").removeClass('active');
										if (!isActive) {
											$(this).addClass('active');
										}
			
										// Toggle content.
										$('.brand-family-block').not('.brand-family-block-' + currentCategory).hide();
										var targetDiv = $('.brand-family-block-' + currentCategory);
										targetDiv.toggle();
									});
			
									// Default to the first category.
									
									// Append toggleButton and categoryBlock to the .brand-family-blocks element.
									$(".brand-family-blocks").append(toggleButton).append(categoryBlock); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
			
									$('.brand-family-block').not('.brand-family-block-operations').hide();
			
									$(".mobile-brand-toggle").removeClass("active");
									$("#mobile-brand-operations").addClass("active");
								}
							});
						});
					};

                    var elem = document.querySelector(".carousel");
                    if(typeof Flickity !== 'undefined') {
                        var flkty = new Flickity(elem, {
                            // options
                            pageDots: false,
                            wrapAround: true
                        });
                    }

                    var loadObject = $(".carousel li").eq(0);
                    if(loadObject.data("region")== ""){
                        $(".header-container").addClass('hide-line');
                    }

                    if(flkty) {
                        flkty.on("select", function() {
                            var selectedObject = $(".carousel li").eq(flkty.selectedIndex);

                            $("#hero-header-text").html(selectedObject.data("header-text"));
                            $("#hero-text").html(selectedObject.data("header-paragraph"));
                            $("#hero-region-header").fadeTo("fast", 0.0, function() {
                                $("#hero-region-header").html(selectedObject.data("region"));
                                if(selectedObject.data("region")== ""){
                                    $(".header-container").addClass('hide-line');
                                }else{
                                    $(".header-container").removeClass('hide-line');
                                }
                            });
                            $("#hero-region-text").fadeTo("fast", 0.0, function() {
                                $("#hero-region-text").html(
                                    selectedObject.data("region-text")
                                );
                            });

                            $("#hero-header-text").fadeTo("fast", 1.0, function() {
                                // Animation complete.
                            });
                            $("#hero-text").fadeTo("fast", 1.0, function() {
                                // Animation complete.
                            });
                            $("#hero-region-header").fadeTo("fast", 1.0, function() {
                                // Animation complete.
                            });
                            $("#hero-region-text").fadeTo("fast", 1.0, function() {
                                // Animation complete.
                            });
                        });
                    }

                    fetchIntlBrands();

                    window.changeCategory = function(category) {
						currentCategory = category;

						// button
						$(".brand-family-industry-tab").removeClass("active");
						$("#btn-industry-" + category).addClass("active");
			
						// content
						$(".brand-family-block").hide();
						$(".brand-family-block-" + currentCategory).show();
                    };
                }
            },
            newsroom: {
                init: function() {
                    var elem = document.querySelector(".carousel");

                    if(typeof Flickity !== 'undefined') {
                        var flkty = new Flickity(elem, {
                            // options
                            pageDots: false,
                            wrapAround: true
                        });
                    }

                    var loadObject = $(".carousel li").eq(0);
                    if(loadObject.data("region") === ""){
                        $(".header-container").addClass('hide-line');
                    }

                    if(flkty) {
                        flkty.on("select", function() {
                            var selectedObject = $(".carousel li").eq(flkty.selectedIndex);

                            $("#hero-header-text").html(selectedObject.data("header-text"));
                            $("#hero-text").html(selectedObject.data("header-paragraph"));
                            $("#hero-region-header").fadeTo("fast", 0.0, function() {
                                $("#hero-region-header").html(selectedObject.data("region"));
                                if(selectedObject.data("region") === ""){
                                    $(".header-container").addClass('hide-line');
                                }else{
                                    $(".header-container").removeClass('hide-line');
                                }
                            });
                            $("#hero-region-text").fadeTo("fast", 0.0, function() {
                                $("#hero-region-text").html(
                                    selectedObject.data("region-text")
                                );
                            });

                            $("#hero-header-text").fadeTo("fast", 1.0, function() {
                                // Animation complete.
                            });
                            $("#hero-text").fadeTo("fast", 1.0, function() {
                                // Animation complete.
                            });
                            $("#hero-region-header").fadeTo("fast", 1.0, function() {
                                // Animation complete.
                            });
                            $("#hero-region-text").fadeTo("fast", 1.0, function() {
                                // Animation complete.
                            });
                        });
                    }
                }
            }
        };

        // The routing fires all common scripts, followed by the page specific scripts.
        // Add additional events for more control over timing e.g. a finalize event
        var UTIL = {
            fire: function(func, funcname, args) {
                var fire;
                var namespace = Sage;
                funcname = funcname === undefined ? "init" : funcname;
                fire = func !== "";
                fire = fire && namespace[func];
                fire = fire && typeof namespace[func][funcname] === "function";

                if (fire) {
                    namespace[func][funcname](args);
                }
            },
            loadEvents: function() {
                // Fire common init JS
                UTIL.fire("common");

                // Fire page-specific init JS, and then finalize JS
                $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
                    i,
                    classnm
                ) {
                    UTIL.fire(classnm);
                    UTIL.fire(classnm, "finalize");
                });

                // Fire common finalize JS
                UTIL.fire("common", "finalize");

                        var menuItem = $('#lc-menu');
                if(typeof getCookie !== 'undefined' && getCookie('showing_lc_menu') === 'false'){

                    menuItem.removeClass("active");
                }else{
                    menuItem.addClass("active");

                }
            }
        };

        // Load Events
        $(document).ready(UTIL.loadEvents);

        // :: PARDOT IFRAME CODE ::
        // Parent Window listening to Pardot iframe (code exists in Pardot template to emit an event on height changes)
        var pardotListener = function(event, iframe) {
            // // Ignore messages from other iframes or windows.
            if (event.origin.indexOf("go.pardot.com") < 0) {
                return;
            }
            // If we get an integer, that is a request to resize the window
            if (!isNaN(parseFloat(event.data)) && isFinite(event.data)) {
                // Math.round() is important to make sure Internet Explorer
                // treats this as an integer rather than a string (especially
                // important if the code below were to add a value to the
                // event.data, although currently we aren't doing that).
                $("iframe.pardotform").height(Math.round(event.data));
            }
        };
        // Setup the Pardot listener
        if (window.addEventListener) {
            addEventListener("message", pardotListener, false);
        } else {
            attachEvent("onmessage", pardotListener);
        }
    })($); // Fully reference $ after this point.

        function getParameterByName(name, url) {
                    if (!url) url = window.location.href;
                    name = name.replace(/[\[\]]/g, "\\$&");
                    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                            results = regex.exec(url);
                    if (!results) return null;
                    if (!results[2]) return '';
                    return decodeURIComponent(results[2].replace(/\+/g, " "));
            }


    $(window).on('load', function() {
        $('.elementor-main-swiper .swiper-slide').on('pointermove', function(e) {
            e.stopPropagation();
            return false;
        });

        var video = getParameterByName('playvideo');

        if (video) {
            var videoElement = $('.elementor-thumbnails-swiper [data-elementor-lightbox-index=' + video + ']').first();

            if (videoElement.length) {
                videoElement.trigger('click');
            }
        }
    });

    $(document).ready(function() {
        $('[data-slick]').slick({
            dots: true,
            adaptiveHeight: true
        });

        if ($('[autojump]').length) {
            $(window).scrollTop($('[autojump]').offset().top);
        }
    });

    function init_brand_grid() {
        var getParameterByName = function(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

		var currentCategory = getParameterByName('category');
		if (!currentCategory) {
			currentCategory = "operations";
		}

        var currentRegion = "united-states";
        var unitedStatesCategoryID = 35;
		var currentCategories =[];

		var fetchCategories = function() {
			$.ajax({
				url: "/wp-json/wp/v2/brand_and_solution_category",
				type: "GET",
				success: function(categories) {
					categories.forEach(function(category) {
						// Check if the category has any posts associated with it.
						if (category.count > 0) {
							currentCategories.push(category.slug); // Add the category slug to currentCategories.
						}
					});
		
					// Once categories are fetched, proceed to fetch brands.
					fetchBrands(0);
				}
			});
		};
		
		fetchCategories();

		var fetchBrands = function(index) {
			if (index < currentCategories.length) { // Iterate over each category.

				var category = currentCategories[index];
				$.ajax({
					url: "/wp-json/wp/v2/brands?orderby=title&order=asc&filter[brand_and_solution_category]=" + category + "&per_page=99",
					type: "GET",
					success: function(brandItems) {

						// Create a div for the category.
						var categoryBlock = $('<div>', {
							class: 'brand-family-block-' + category + ' brand-family-block'
						}); 
						
						$.each(brandItems, function(index, brandItem) {
							if (
								currentRegion === "united-states" &&
								$.inArray(unitedStatesCategoryID, brandItem.region) < 0
							) {
								return;
							}
							if (
								currentRegion === "intl" &&
								$.inArray(unitedStatesCategoryID, brandItem.region) === 0 &&
								brandItem.region.length === 1
							) {
								return;
							}
							var regional_text = currentRegion === "intl" ? brandItem.meta_box.regional_text : brandItem.meta_box.regional_text_us;
							var brand_url = brandItem.meta_box.brand_external_url.length > 0 ?
								brandItem.meta_box.brand_external_url : brandItem.link;
							var dark_logo = brandItem.meta_box.brand_dark_logo.length > 0 ?
								brandItem.meta_box.brand_dark_logo[0].full_url : "";
							var white_logo = brandItem.meta_box.brand_white_logo.length > 0 ?
								brandItem.meta_box.brand_white_logo[0].full_url : "";

							// Create elements.
							var brandBlockLink = document.createElement("a");
							brandBlockLink.href = brand_url;
							brandBlockLink.className = "brand-block";

							var brandBlockOverlay = document.createElement("div");
							brandBlockOverlay.className = "brand-block_overlay";

							var darkLogoImg = document.createElement("img");
							darkLogoImg.className = "dark-logo";
							darkLogoImg.src = dark_logo;

							var whiteLogoImg = document.createElement("img");
							whiteLogoImg.className = "white-logo";
							whiteLogoImg.src = white_logo;

							var countryInfoSpan = document.createElement("span");
							countryInfoSpan.className = "country-info";
							countryInfoSpan.textContent = regional_text;

							// Assemble elements.
							brandBlockOverlay.appendChild(darkLogoImg);
							brandBlockOverlay.appendChild(whiteLogoImg);
							brandBlockOverlay.appendChild(countryInfoSpan);

							brandBlockLink.appendChild(brandBlockOverlay);

							// Append to categoryBlock.
							categoryBlock.append(brandBlockLink); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append

						});
						
						// Create the elements using DOM node construction.
						var toggleButton = $('<div>', {
							class: 'mobile-brand-toggle',
							id: 'mobile-brand-' + category,
							'data-category': category
						}).append( // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
							$('<div>').text(category.toUpperCase()),
							$('<i>', { class: 'fa fa-chevron-down' })
						);

						toggleButton.on('click', function() {
							var currentCategory = $(this).data('category'); // Define currentCategory within the click event handler
						
							// Toggle button.
							var isActive = $(this).hasClass('active');
							$(".mobile-brand-toggle").removeClass('active');
							if (!isActive) {
								$(this).addClass('active');
							}
						
							// Toggle content with a callback for scrolling after animation.
							$('.brand-family-block').not('.brand-family-block-' + currentCategory).slideUp();
						
							// Toggle the target content after the slideUp animation completes.
							var targetDiv = $('.brand-family-block-' + currentCategory);
							targetDiv.slideToggle(400, function() {
								if ($('.brand-family-block-' + currentCategory).is(':visible')) {
									$('html,body').animate({scrollTop: $("#mobile-brand-" + currentCategory).offset().top - 60 }, 400);
								}
							});
						});
						
						// One active category.
						
						$(".brand-family-blocks").append(toggleButton).append(categoryBlock); // phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.append
						$('.brand-family-block').not('.brand-family-block-' + currentCategory).hide();

						$(".mobile-brand-toggle").removeClass("active");
						$("#mobile-brand-" + currentCategory).addClass("active");

						fetchBrands(index + 1);
					}
				});
			};
		};

        fetchBrands();

        window.changeRegion = function(region) {
            $(".brand-family-country-tab").removeClass("active");
            $("#btn-country-" + region).addClass("active");
            currentRegion = region;

            // fetchBrands();

            if(region === 'intl') {
                $('#btn-industry-mobility').hide();
            }
            else {
                $('#btn-industry-mobility').show();
            }
        };

        window.changeCategory = function(category) {
			currentCategory = category;

			// desktop toggle.
            $(".brand-family-industry-tab").removeClass("active");
            $("#btn-industry-" + category).addClass("active");

			$(".brand-family-block").hide();
			$(".brand-family-block-" + currentCategory).show();

			// mobile toggle.
			$(".brand-family-block").not(".brand-family-block-" + category).hide();
			$(".mobile-brand-toggle").removeClass("active");
			$("#mobile-brand-" + category).addClass("active");
        };

        // on page load, look for query string
        var country = getParameterByName('country');
        // if query string present , call...
        if (country) {
            changeRegion(country);
            changeCategory(getParameterByName('category'));
            $('html,body').animate({scrollTop: $('#brand_grid').offset().top}, 400);
        }
        // changeRegion(#query-string-region);
        // changeCategory(#query-string-category);
    }

components.headerHub.init();